module.exports = __webpack_public_path__ + "img/seven2Red.fb7ee2d6.jpg";